export default "__VITE_ASSET__BMkySaHm__"